import { Button, ErrorMessage, Flex, Label, Text } from "@jsq/ds/core";
import { FormRadioBar, useFormContext } from "@jsq/ds/forms";
import { Colors, Sizes } from "@jsq/ds/styles";
import { FormValues as BankAccountFormValues } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/BankAccountCard/CreateBankAccountAction/types";
import { FormValues as EntityFormValues } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/common/EditAction/EditEntityForm/types";
import { FormValues as IndividualFormValues } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/common/EditAction/EditIndividualForm/types";
import { SPACING } from "~/styles/variables";

type Props = {
  form: string;
  nonOverrideRiskRating?: string;
};

const RiskRatingRadioBar = ({ form, nonOverrideRiskRating }: Props) => {
  const individualFormValues = useFormContext<IndividualFormValues>();
  const entityFormValues = useFormContext<EntityFormValues>();
  const bankAccountFormValues = useFormContext<BankAccountFormValues>();
  const { values, setFieldValue } =
    form === "individual"
      ? individualFormValues
      : form === "entity"
        ? entityFormValues
        : bankAccountFormValues;
  return (
    <Flex style={{ marginBottom: SPACING.MEDIUM }}>
      <div>
        <Label>Risk Rating</Label>
        <FormRadioBar
          name="riskRating"
          size="small"
          style={{ justifyContent: "center" }}
          options={[
            { label: "Low", value: "low" },
            { label: "Medium", value: "medium" },
            { label: "High", value: "high" },
            { label: "Halt", value: "halt" },
          ]}
        />
        {values.riskRating && values.riskRating != "none" && values.riskRating != "" && (
          <Flex style={{ marginBottom: SPACING.MEDIUM }}>
            <Flex flexDirection="column">
              <ErrorMessage style={{ marginTop: Sizes.XS }}>Manually overridden</ErrorMessage>
              <Flex gap={SPACING.SMALL}>
                {nonOverrideRiskRating && (
                  <>
                    <Text style={{ color: Colors.Neutral600 }}>Non-overridden rating:</Text>
                    <Text>
                      {nonOverrideRiskRating.charAt(0).toUpperCase() +
                        nonOverrideRiskRating.slice(1)}
                    </Text>
                  </>
                )}
                <Button displayAsLink onClick={() => setFieldValue("riskRating", "none")}>
                  Reset
                </Button>
              </Flex>
            </Flex>
          </Flex>
        )}
      </div>
    </Flex>
  );
};

export default RiskRatingRadioBar;
